import React, { createContext, useContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [contextState, setState] = useState({
        myAccountOpen: false,
      modalOpen: ""
    });
  
    const toggleAccountMenu = (key,value) => {
      setState((prevState) => ({
        ...prevState,
        [key]: value
      }));
    };
  
    const toggleModalfromContext = (value) => {
      setState((prevState) => ({
        ...prevState,
        modalOpen: value
      }));
    };
  
    const contextValue = {
      contextState,
      toggleModalfromContext,
      toggleAccountMenu
    };
  
    return (
      <AppContext.Provider value={contextValue}>
        {children}
      </AppContext.Provider>
    );
  };
  